:host {
  --md-icon-size--xs: var(--md-size--xs);
  --md-icon-size--sm: var(--md-size--sm);
  --md-icon-size--md: var(--md-size--md);
  --md-icon-size--lg: var(--md-size--lg);
  --md-icon-size--xl: var(--md-size--xl);
  --md-icon-outline-focus: var(--md-outline-focus);
  --md-icon-outline-offset-focus: var(--md-spacing-unit--3xs);
  --md-icon-display: inline-flex;
  --md-icon-position: relative;
  display: var(--md-icon-display);
  position: var(--md-icon-position);
  --md-icon-outline-radius-focus: 0;
}

.md-icon {
  align-items: center;
  display: inline-flex;
  justify-content: center;
}

.md-icon ::slotted(svg),
.md-icon ::slotted(img) {
  filter: inherit;
  height: 100%;
  object-fit: contain;
  width: 100%;
}

@import './md-icon-colors.css';
@import './md-icon-colors-hover.css';

/* Rotation */

.md-icon.md-icon-rotate--up {
  transform: rotate(0deg);
}

.md-icon.md-icon-rotate--up-right {
  transform: rotate(45deg);
}

.md-icon.md-icon-rotate--right {
  transform: rotate(90deg);
}

.md-icon.md-icon-rotate--right-down {
  transform: rotate(135deg);
}

.md-icon.md-icon-rotate--down {
  transform: rotate(180deg);
}

.md-icon.md-icon-rotate--down-left {
  transform: rotate(225deg);
}

.md-icon.md-icon-rotate--left {
  transform: rotate(270deg);
}

.md-icon.md-icon-rotate--left-up {
  transform: rotate(315deg);
}

.md-icon.md-icon-animate--spin-right {
  animation: spinRight 2s linear infinite;
}

.md-icon.md-icon-animate--spin-left {
  animation: spinLeft 2s linear infinite;
}

/* Size */
.md-icon.md-icon-size--xs {
  height: var(--md-icon-size--xs);
  width: var(--md-icon-size--xs);
}

.md-icon.md-icon-size--sm {
  height: var(--md-icon-size--sm);
  width: var(--md-icon-size--sm);
}

.md-icon.md-icon-size--md {
  height: var(--md-icon-size--md);
  width: var(--md-icon-size--md);
}

.md-icon.md-icon-size--lg {
  height: var(--md-icon-size--lg);
  width: var(--md-icon-size--lg);
}

.md-icon.md-icon-size--xl {
  height: var(--md-icon-size--xl);
  width: var(--md-icon-size--xl);
}

.md-icon.md-icon--as-button {
  cursor: pointer;
}

.md-icon.md-icon--as-button:focus-visible {
  outline: var(--md-icon-outline-focus);
  outline-offset: var(--md-icon-outline-offset-focus);
  border-radius: var(--md-icon-outline-radius-focus);
}

@keyframes spinRight {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes spinLeft {
  0% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
